import { FC } from 'react';
import BGMaskedInput from '../BGMaskedInput/BGMaskedInput';
import { amountMask, IAmountOptions } from './utils/amountMask';
import { IInputProps } from '../interfaces';

interface IProps extends IInputProps {
    options: IAmountOptions;
}

const BGAmountInput: FC<IProps> = (props) => {
    const validRegex = `^\\d{1,${props.options.integerMaxLength}}.\\d{${props.options.currencyPrecision}}$`;

    return (
        <BGMaskedInput<IAmountOptions>
            maskFunc={amountMask}
            value={props.value}
            onChange={props.onChange}
            options={{ ...props.options, validRegex }}
            inputClassName={props.inputClassName}
            containerClassName={props.containerClassName}
            currencySignClassName={props.currencySignClassName}
        />
    );
};

export default BGAmountInput;
